import React, { FC, useEffect, useState } from "react"
import { Footer as FooterComponent } from "@bancacfplus/Footer"
import { useGenerateCobrowseCode } from "../Cobrowse/hooks/useGenerateCobrowseCode"
import { CobrowseModal } from "../Cobrowse"
import { spellOutForScreenReader } from "../../utils/spellOutForScreenReader"
import { brand } from "../../consts/brand"
import style from "./Footer.module.scss"

export const Footer: FC = () => {
  const [assistanceCode, setAssistanceCode] = useState<string | null>(null)
  const { loading, error, code, generate } = useGenerateCobrowseCode()

  useEffect(() => {
    if (code) {
      setAssistanceCode(code)
    }
  }, [code])

  return (
    <>
      <FooterComponent>
        <FooterComponent.Logo />
        <FooterComponent.Links title={""}>
          <a href={`${brand.websiteUrl}/legal-disclaimer/`} target="_blank" rel="noreferrer">
            Note Legali
          </a>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <a href={`${brand.websiteUrl}/privacy-policy/`} target="_blank" rel="noreferrer">
            Privacy
          </a>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <button className={style.action} onClick={generate}>
            Supporto clienti
          </button>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <a href={"/privacy"}>Gestione consensi</a>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
        </FooterComponent.Links>
        <FooterComponent.Copy>
          <p>
            {brand.legalName} {brand.address} | P. IVA{" "}
            <span aria-label={`Partita IVA ${spellOutForScreenReader(brand.vatNumber)}`}>{brand.vatNumber}</span>{" "}
            Copyright 2026 - All Right Reserved
          </p>
        </FooterComponent.Copy>
      </FooterComponent>
      <CobrowseModal
        code={assistanceCode}
        closeHandler={setAssistanceCode}
        loading={loading}
        error={error}
        generateCode={generate}
      />
    </>
  )
}

export default Footer
